import styled from "styled-components";

export const RangeSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  touch-action: none; // 🔒 Evita comportamento de scroll no mobile
`;

export const StyledTrack = styled.div`
  position: absolute;
  width: 100%;
  height: 6px;
  background: ${({ theme }) => theme.colors.lightGray};
  border-radius: 3px;
`;

export const StyledRange = styled.div`
  position: absolute;
  height: 6px;
  background: ${({ theme }) => theme.colors.mediumBlue};
  border-radius: 3px;
  pointer-events: none;
`;

export const StyledThumb = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background: ${({ theme }) => theme.colors.mediumBlue};
  border-radius: 50%;
  cursor: grab;
  transform: translate(-50%, -50%);
  top: 50%;
  z-index: 2;
  touch-action: none; // Evita conflito de scroll/zoom do navegador

  &:active {
    cursor: grabbing;
  }
`;
